import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ForecastItemManagerService } from 'src/services/forecast-services/item-manager.service';

@Component({
  selector: 'product-item-edit-cell-renderer',
  template: `<a class="product-title-link" [title]="params.value" (click)="btnEditClickHandler()">{{params.value}}</a>`,
})
export class ProductItemEditRenderer implements ICellRendererAngularComp, OnDestroy {
  params: any;

  constructor(private itemManagerService: ForecastItemManagerService) {
  }

  agInit(params: any): void {
    this.params = params;
  }

  btnEditClickHandler() {
    this.itemManagerService.setProductGridActionCellSubject({ itemData: this.params.data });
  }

  refresh(params?: any): boolean {
    return true;
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
